/**
 * @owner @Appboy/messaging-experience
 */
import type { SelectableMessageType } from "@lib/campaignMessageTypeConstants";

import { isPrioritizableChannelSelection } from "./isPrioritizableChannelSelection";
import type { MessagePrioritizationIneligibleReason } from "./types";

/**
 * Classifies why a channel selection cannot use Message Prioritization.
 * Multichannel wins over a single ineligible channel so the UI shows one warning.
 *
 * @param types - Currently selected message types on the step.
 * @returns `undefined` when the selection is prioritizable.
 */
export const getMessagePrioritizationIneligibleReason = (
  types: readonly SelectableMessageType[]
): MessagePrioritizationIneligibleReason | undefined => {
  if (isPrioritizableChannelSelection(types)) {
    return undefined;
  }
  if (types.length > 1) {
    return "multichannel";
  }
  return "channelIneligible";
};
